var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white fixed bottom-0 w-full  pb-0-safe pb-safe "},[_c('div',{staticClass:"w-full flex px-4 py-4 tabbar-nav"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }